export default "__VITE_ASSET__16c4a13a__"